import { useFormik } from "formik";
import { useState } from "react";
import { DatePickerConfig } from "../types/DatePickerConfig.type";
import { buildDatePickerRange } from "shared/utils/helpers/buildDatePickerRange";

export const useHookFormExportedPackages = (
  setShowForm?: (value: boolean) => void,
  onApplyFilters?: (filters: any) => void,
) => {
  const [exportDateRange, setExportDateRange] = useState<any[]>([null, null]);
  const [startExportDate, endExportDate] = exportDateRange;

  const { handleChange, handleSubmit, values, resetForm } = useFormik({
    initialValues: {
      nit: "",
      paymentConsecutive: "",
      exportStatus: "",
    },
    onSubmit: (vls) => {
      const filters = {
        ...vls,
        exportDateRange: {
          start: startExportDate,
          end: endExportDate,
        },
      };
      onApplyFilters && onApplyFilters(filters);
      setShowForm && setShowForm(false);
    },
    validateOnChange: false,
    enableReinitialize: true,
  });

  const getDatePickerConfig = (): DatePickerConfig => ({
    exportDateRange: buildDatePickerRange(startExportDate, endExportDate),
  });

  const getValueDatePickerStart = (name: keyof DatePickerConfig): Date | null =>
    getDatePickerConfig()[name]!.start();

  const getValueDatePickerEnd = (name: keyof DatePickerConfig): Date | null =>
    getDatePickerConfig()[name]!.end();

  const maxDate = (name: keyof DatePickerConfig): Date =>
    getDatePickerConfig()[name]!.max();

  const onChangesDatePicker = (update: any, name: string) => {
    if (name === "exportDateRange") setExportDateRange(update);
  };

  const handleUserAssignment = () => {
    // No se requiere para este formulario
  };

  const handleClear = () => {
    resetForm();
    setExportDateRange([null, null]);
    onApplyFilters && onApplyFilters(null);
    setShowForm && setShowForm(false);
  };

  return {
    handleSubmit,
    handleChange,
    getValueDatePickerStart,
    getValueDatePickerEnd,
    maxDate,
    onChangesDatePicker,
    values,
    handleUserAssignment,
    handleClear,
  };
};
